import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import EditIcon from '@icons/common/edit.svg';
import DeleteIcon from '@icons/common/delete.svg';
import InfoIcon from '@icons/common/help.svg';
import { setForm } from '@store/policies/schedule/actions';
import { formModes } from '@store/policies/schedule/formReducer';
import { messageMap, scheduleStatus } from '@store/policies/schedule/utils';
import { IconWrap, StatusIconWrap } from './styled';
import { formatRecordForForm } from './utils';
import InfoModal from './InfoModal';

const ActionCell = ({ rowData }) => {
  const dispatch = useDispatch();
  const { state } = rowData;
  const isStatePending = state === scheduleStatus.pending;

  const [visible, setVisible] = useState(false);

  const handleEdit = () => {
    dispatch(
      setForm({
        ...formatRecordForForm(rowData),
        mode: formModes.edit,
      }),
    );
  };

  const handleDelete = () => {
    dispatch(
      setForm({
        ...formatRecordForForm(rowData),
        mode: formModes.delete,
      }),
    );
  };

  const handleInfo = () => {
    setVisible(true);
  };

  const backgroundColor = messageMap[state]?.backgroundColor;

  return (
    <div>
      <InfoModal visible={visible} rowData={rowData} setVisible={setVisible} />
      {isStatePending ? (
        <>
          <IconWrap style={{ fontSize: '1em' }}>
            <EditIcon onClick={handleEdit} />
          </IconWrap>
          <IconWrap style={{ fontSize: '1em' }}>
            <DeleteIcon onClick={handleDelete} />
          </IconWrap>
        </>
      ) : (
        <StatusIconWrap backgroundColor={backgroundColor || 'white'}>
          <InfoIcon onClick={handleInfo} />
        </StatusIconWrap>
      )}
    </div>
  );
};

export default ActionCell;
